module.exports = __webpack_public_path__ + "static/media/Successful.312b1c74.svg";